import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

interface ArtistBioResourceQueryOptionsInput {
  artistId: string;
  locale: string;
}

export function getArtistBioResourceQueryOptions({
  artistId,
  locale,
}: ArtistBioResourceQueryOptionsInput) {
  return deferredResourceQueryOptions(
    orpc.music.getArtistBioResource.queryOptions({
      input: { artistId, locale },
    }),
  );
}
